import { render, staticRenderFns } from "./SmartLink.vue?vue&type=template&id=32889957&scoped=true"
import script from "./SmartLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SmartLink.vue?vue&type=style&index=0&id=32889957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32889957",
  null
  
)

export default component.exports